"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDrawArrow = exports.DrawArrow = void 0;
const GeometryType_1 = __importDefault(require("ol/geom/GeometryType"));
const Draw_1 = __importDefault(require("ol/interaction/Draw"));
const proj_1 = require("ol/proj");
const react_1 = require("react");
const useOLMap_1 = require("../openlayers/useOLMap");
function DrawArrow({ onDraw, }) {
    useDrawArrow({ onDraw });
    return null;
}
exports.DrawArrow = DrawArrow;
function useDrawArrow({ onDraw, }) {
    const onDrawRef = react_1.useRef(onDraw);
    const map = useOLMap_1.useOLMap();
    react_1.useEffect(() => {
        onDrawRef.current = onDraw;
    }, [onDraw]);
    const interaction = react_1.useMemo(() => {
        return new Draw_1.default({
            type: GeometryType_1.default.LINE_STRING,
            maxPoints: 2,
            minPoints: 2,
        });
    }, []);
    react_1.useEffect(() => {
        map.addInteraction(interaction);
        return () => {
            map.removeInteraction(interaction);
        };
    }, [map, interaction]);
    react_1.useEffect(() => {
        const onDraw = (event) => {
            const geometry = event.feature.getGeometry();
            if (geometry.getType() !== GeometryType_1.default.LINE_STRING) {
                throw new Error('No line string');
            }
            const lineString = geometry;
            onDrawRef.current(proj_1.toLonLat(lineString.getFirstCoordinate()), proj_1.toLonLat(lineString.getLastCoordinate()));
        };
        interaction.on('drawend', onDraw);
        return () => {
            interaction.un('drawend', onDraw);
        };
    }, [map, interaction]);
}
exports.useDrawArrow = useDrawArrow;
exports.default = DrawArrow;
//# sourceMappingURL=DrawArrow.js.map